import { ActionSet } from '../types';

/**
 * Creates an action set with all the possible states.
 *
 * @param {string} name
 * @returns {ActionSet}
 */
export const createActionSet = (name: string): ActionSet => Object.freeze({
  ACTION: name,
  PENDING: `${name}_PENDING`,
  FULFILLED: `${name}_FULFILLED`,
  REJECTED: `${name}_REJECTED`
});
